// Always use America/New_York instead of US/Eastern in modern JavaScript, React apps,
// and any system that uses the IANA time zone database.

export const DEFAULT_TIME_ZONE = 'America/New_York';

export const TIME_ZONES = [
  { label: 'Eastern Time (EST)', value: 'America/New_York' },
  { label: 'Central Time (CST)', value: 'America/Chicago' },
  { label: 'Pacific Time (PST)', value: 'America/Los_Angeles' },
  { label: 'Western European Time (WET, London)', value: 'Europe/London' },
  { label: 'Central European Time (CET, Oslo/Berlin)', value: 'Europe/Oslo' },
  { label: 'Eastern European Time (EET, Helsinki/Athens)', value: 'Europe/Helsinki' }
];
